import axios from "axios";

export const addDefaultStoreCommission = {
  async addDefaultStoreCommission({ commit }, { current_store_id, payload }) {
    const response = await axios.post(`stores/${current_store_id}/add-store-commission`, { ...payload })
  }
}
